import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-success.png'


const _withScopeId = n => (_pushScopeId("data-v-73ea5806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-oc-submit-success" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_6 = { class: "title" }

import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter, useRoute } from 'vue-router';

  interface IProps {
    type: 'PDO' | 'OfflineCollection';
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
    type: 'PDO' | 'OfflineCollection';
  }

  
  const route = useRoute();
  const router = useRouter();
  const { t } = useI18n();
  const replaceNameMap = {
    'PDO': 'pdo.submission-new',
    'OfflineCollection': 'mine.offline_collections.detail'
  };

  onMounted(() => {});

  function handleClickStartOver() {
    router.replace({ name: replaceNameMap[props.type], params: route.params, query: route.query });
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(route).query.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t)('offline_collection.form.Submitted Successfully!')), 1),
      _createElementVNode("div", {
        class: "over-button",
        onClick: handleClickStartOver
      }, _toDisplayString(__props.type === 'OfflineCollection' ? _unref(t)('offline_collection.form.Check my OC records') : _unref(t)('offline_collection.form.Start Over')), 1)
    ])
  ]))
}
}

})